import { RunReportResult } from '../types/runReportResult';
import { IReportDefinition } from '../types/reportDefinition';
import api from './Api';
import { DAXReportRequest } from 'src/types/daxReportRequest';
import { CustomerSales, ProductGroupSales, SalesRepPerformance, VendorSales } from 'src/types/daxReportResponse';

async function getReportCategories(): Promise<any[]> {
  return api.get<any[]>('/Report/Categories');
}

async function getReportList(categoryId: string): Promise<any[]> {
  return api.get<any[]>(`/Report/List?categoryId=${categoryId}`);
}

async function getReportDefinition(companyUserId: number, customerNumber: string, reportId: string): Promise<IReportDefinition> {
  return api.get<IReportDefinition>(`/Report/Definition?reportId=${reportId}&customerNumber=${customerNumber}&companyUserId=${companyUserId}`);
}

async function getReport(customerNumber: string, report: IReportDefinition, isSpreadsheet: boolean): Promise<RunReportResult> {
  return api.post<RunReportResult>(`/Report?customerNumber=${customerNumber}&isSpreadsheet=${isSpreadsheet}`, report);
}

//DAX Reports
async function getCustomerSalesByProductGroup(request: DAXReportRequest): Promise<ProductGroupSales[]> {
  return api.post<ProductGroupSales[]>('/Report/DAX/Customer/Product-Group', request);
}

async function getSalesByVendor(request: DAXReportRequest): Promise<VendorSales[]> {
  return api.post<VendorSales[]>('/Report/DAX/Vendor', request);
}

async function getSalesByRep(request: DAXReportRequest): Promise<SalesRepPerformance[]> {
  return api.post<SalesRepPerformance[]>('/Report/DAX/Sales', request);
}

async function getSalesByCustomer(request: DAXReportRequest): Promise<CustomerSales[]> {
  return api.post<CustomerSales[]>('/Report/DAX/Customer', request);
}

export default {
  getReportCategories,
  getReportList,
  getReportDefinition,
  getReport,
  getCustomerSalesByProductGroup,
  getSalesByVendor,
  getSalesByCustomer,
  getSalesByRep,
};
